module.exports = require("stickyfill");